/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import './index.scss';
import { List, Button, Modal, Label, bindMethods } from '../common';
import Form from './Form';

const duration = (a, b) => {
  const [aHour, aMin] = (a || '').split(':');
  const [bHour, bMin] = (b || '').split(':');
  const d = Math.abs(((+bHour * 60) + +bMin) - ((+aHour * 60) + +aMin));
  const dh = parseInt(d / 60, 10);
  const dm = d - (dh * 60);

  return [
    dh ? `${dh}hrs` : '',
    dm ? `${dm}mins` : '',
  ].join(' ');
};

const isSetupComplete = (softwares) => {
  return !!(softwares && softwares.info && softwares.info.STUDIO_ID);
};

export const isStaffType = (type) => {
  return ['STAFF', 'STAFF_BREAK'].includes(type);
};

export default class Schedules extends React.Component {
  constructor() {
    super();
    this.state = {
      form: false,
      modal: '',
      modalData: {},
    };
    bindMethods(this, ['show', 'close', 'openModal', 'closeModal']);
  }

  componentDidMount() {
    this.props.getSchedules();
  }

  show(form) {
    this.setState({
      form,
    });
  }

  close() {
    this.setState({
      form: false,
    });
  }

  openModal(modal, modalData) {
    this.setState({
      modal,
      modalData,
    });
  }

  closeModal() {
    this.setState({
      modal: '',
    });
  }

  render() {
    const { show, close, state, openModal, closeModal } = this;
    const { form, modal, modalData } = state;
    const { saveSchedule, removeSchedule, softwares } = this.props;

    let schedules = [];
    let staffMembers = [];

    if (this.props.schedules && this.props.schedules.list && this.props.schedules.list.length) {
      schedules = this.props.schedules.list;
    }
    if (this.props.schedules
        && this.props.schedules.staffMembers
        && this.props.schedules.staffMembers.length) {
      staffMembers = this.props.schedules.staffMembers;
    }

    return (
      <div className="staff">
        <div className="card" style={{ overflow: 'unset' }}>
          <div className="card__header">
            <span className="card__header__text">
              Schedules
            </span>
            {
              isSetupComplete(softwares) ?
                <Button
                  className="btn--link"
                  onClick={() => {
                    show({});
                  }}
                >+ Add New Schedules</Button> :
                null
            }
          </div>
          <div className="card__content">
            <div className="voicemails__list">
              <List
                headers={[
                  { label: 'Weekdays' },
                  { label: 'For' },
                  { label: 'Time' },
                  { label: 'Duration' },
                  { label: '' },
                ]}
                rows={schedules}
                loading={this.props.schedules.loading}
              >
                {(row) => {
                  return (
                    <tr
                      key={row.id}
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        show(row);
                      }}
                    >
                      <td>{(row.day || []).join(',')}</td>
                      <td>
                        <div>
                          {row.type}
                        </div>
                        {isStaffType(row.type)
                        && ((row.staff || []).map((member) => {
                          return (
                            <div key={member.id}>{`${member.first_name} ${member.last_name}`}</div>
                          );
                        }))}</td>
                      <td>{`${moment(row.start, 'HH:mm:ss').format('hh:mm a')} - ${moment(row.end, 'HH:mm:ss').format('hh:mm a')}`}</td>
                      <td>{duration(row.slot.start, row.slot.end)}</td>
                      <td>
                        <i
                          className="material-icons"
                          style={{
                            cursor: 'pointer',
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            openModal('del', row);
                          }}
                        >delete</i>
                      </td>
                    </tr>
                  );
                }}
              </List>
            </div>
          </div>
          <Form
            key={(form && form.id) || Math.random()}
            show={!!form}
            values={form}
            onClose={close}
            onSave={saveSchedule}
            staffMembers={staffMembers}
          />
          <Modal
            open={modal === 'del'}
            title="Delete Schedule"
            onClose={() => {
              closeModal();
            }}
          >
            <Label style={{ display: 'block' }} type="form">
              Are you sure you want to delete this schedule:
            </Label>
            <Label style={{ display: 'block' }} type="form">{`${(modalData.schedule || []).join(',')} ${modalData.start} ${modalData.end}`}</Label>
            <div
              style={{
                textAlign: 'right',
                marginTop: 30,
              }}
            >
              <Button
                type="primary"
                style={{
                  marginRight: 20,
                }}
                onClick={() => {
                  removeSchedule(modalData.id);
                  closeModal();
                }}
              >Delete</Button>
              <Button
                type="simple"
                onClick={() => {
                  closeModal();
                }}
              >Close</Button>
            </div>
          </Modal>
        </div>
      </div>
    );
  }
}

Schedules.defaultProps = {
  getSchedules: () => {},
  saveSchedule: () => {},
  removeSchedule: () => {},
};

Schedules.propTypes = {
  getSchedules: PropTypes.func,
  saveSchedule: PropTypes.func,
  removeSchedule: PropTypes.func,
  schedules: PropTypes.shape({
    list: PropTypes.array.isRequired,
    staffMembers: PropTypes.array,
    loading: PropTypes.bool,
  }).isRequired,
  softwares: PropTypes.shape({
    info: PropTypes.shape({
      STUIDIO_NAME: PropTypes.string,
    }),
  }).isRequired,
};
